import React, { useEffect, useState } from "react";
import Loading from "../Loading";
import Member from "./Member";
import Executive from "./Executive";

const AuthenticatedHome = (props) => {
    const [roles, setRole] = useState()

    useEffect(()=>{
        setRole(props.userInfo.roles[0].role.roleid)
    },[props])
    
    return (
        <>
        {roles ? 
            roles === 1 ? <Member userInfo={props.userInfo}/> : <Executive userInfo={props.userInfo}/> : <Loading/> 
        }
        </>
    );
};

export default AuthenticatedHome;